import React from "react";

export default function QuietFooter({ content }) {
  const text = Array.isArray(content) ? content.join(" ") : content;

  return (
    <div className="sx-footer-inner">
      {text}
      <div className="sx-footer-brand">
        SysMindX Astro is a platform by{" "}
        <a
          href="https://sysmindx.com"
          className="sx-footer-brand-link"
          target="_blank"
          rel="noopener noreferrer"
        >
          SysMindX Solutions
        </a>
      </div>
    </div>
  );
}
